import { useQuery } from "@tanstack/react-query"
import { getProgramBookingTicketCheckWebByProgramBookingId } from "../../../../../../../../service/programBooking"

const useGetProgramBookingTicketCheckWebByProgramBookingId = <T,>(programBookingId: number, responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['getProgramBookingTicketCheckWebByProgramBookingId', programBookingId, responseQuery],
        queryFn: () => getProgramBookingTicketCheckWebByProgramBookingId<T>(programBookingId, responseQuery),
        enabled: !!programBookingId,
        select: res => res.data.data.getProgramBookingTicketCheckWebByProgramBookingId
    })

    return query
}

export { useGetProgramBookingTicketCheckWebByProgramBookingId }